// extracted by mini-css-extract-plugin
export var label = "_hv-2";
export var slideContainer = "_hv-0";
export var slider = "_hv-1";